<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div class="wordtitle">
          开放API能力
        </div>
        <div class="smallitle">
          / Open API capability
        </div>
      </div>
    </div>

    <div class="container">

     <div class="breadcrumbBox">
       <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>开放服务</el-breadcrumb-item> -->
        <el-breadcrumb-item><span class="curPage">开放API能力</span></el-breadcrumb-item>
      </el-breadcrumb>
     </div>
     <div class="tabBar">
        <div class="tabName" :class="{'active': ptIndex === idx}" v-for="(item, idx) in list" :key="idx" @click="changeData(idx, item.id)">{{item.name}}</div>
      </div>
      <div class="content">
         <!--一条数据start-->
         <div class="apiBlock">
           <div class="topBox">
             <div class="topLeftBox">
              <img class="apiIcon" src="../../assets/images/apiOpenIcon.png" />
              <div>
                  <div class="tit">数据名称数据名称</div>
                  <div class="method">post</div>
              </div>
             </div>
             <span class="blueBtn" @click="handleOpen">申请开通</span>
           </div>
           <div class="botBox">
             <div><span>访问地址：</span>https://platform.iiasx.org.cn/dps/#/screenTwo?isQP=true</div>
             <div><span>详情：</span>Apifox 是 API 文档、API 调试、API Mock、API 自动化测试一体化协作平台</div>
           </div>
         </div>
         <!--一条数据end-->
      </div>

     <div>

     </div>

    </div>
    <Footer />
    <!--申请开通接口服务弹窗-->
    <ApiServiceDialog :dialogData='dialogVisible' @changeVisible="changeVisible"></ApiServiceDialog>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import ApiServiceDialog from '@/components/apiServiceDialog.vue'

export default {
  data() {
    return {
      list:[
        {
          name:'全部',
          id: '',
        },
        {
          name: '其他',
          id: 1,
        }
      ],
      ptIndex: 0,
      dialogVisible: false,
    }
  },
  components: {
      Header,
      Footer,
      ApiServiceDialog
  },
  methods: {
    changeData(idx, id) {
       this.ptIndex = idx
       this.getList(id)
     },
     getList(id) {
       console.log('todo')
     },
     handleOpen() {
       this.dialogVisible = true
     },
     changeVisible(data) {
       this.dialogVisible = data
     }
  }
}
</script>
<style scoped>
.banner {
    width: 100%;
    height: 480px;
    background: url('../../assets/images/apiOpenBanner.png') top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .word {
    width: 1300px;
    margin: 160px auto 0;
  }

  .smallitle {
    width: 653px;
    height: 40px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #E1E2E6;
    line-height: 24px;
    margin-top: 40px;
  }

  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }
  .container {
    width: 1300px;
    margin: 0 auto;
    box-sizing: border-box;
    /* display: flex;
    align-items: center;
    justify-content: center; */
    background: #FBFBFB;
  }
  .breadcrumbBox{
    padding: 58px 0 54px;
  }
  .breadcrumbBox /deep/ .el-breadcrumb__inner.is-link{
    font-weight: normal;
    color: #606266;
  }
  .breadcrumbBox .curPage{
    font-weight: 700;
    color: #303133;
  }
  .tabBar{
  border-bottom: 1px solid #DADFE7;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.tabName{
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #909DB1;
  padding: 0 18px 14px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  position: relative;
  top: 1px;
  margin-right: 20px;
}
.tabName:hover{
  color: #0F5EFF;
  border-bottom: 2px solid #0F5EFF;
}
.tabName.active{
  color: #0F5EFF;
  border-bottom: 2px solid #0F5EFF;
}

.content{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}
.apiBlock{
  width: 630px;
  background: #FFFFFF;
  box-shadow: 1px 5px 16px 0px rgba(220,221,236,0.3);
  border-radius: 8px;
  padding: 24px 30px;
  box-sizing: border-box;
  margin: 0px 0 16px 0;
}
.apiBlock .topBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.apiBlock .topBox .blueBtn{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  background: #0F5EFF;
  border-radius: 23px;
  cursor: pointer;
  height: 46px;
  line-height: 46px;
  padding: 0 29px;
}
.topLeftBox .apiIcon{
  width: 92px;
  height: 92px;
  margin-right: 28px;
}
.topLeftBox{
  display: flex;
  flex-direction: row;
  flex: 1;
}
.topLeftBox .tit{
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  padding-top: 17px;
}
.topLeftBox .method{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #0F5EFF;
  padding: 7px 20px;
  background: #EDF2FF;
  display: inline-block;
  border-radius: 2px;
  margin-top: 17px;
}
.botBox{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  padding-left: 6px;
}
.botBox span{
  color: #909DB1;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/OpenList.vue